import React from 'react';
import Filters from '../../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onBranchSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_id: [...(prevState.branch_id || []), selectedOption.id] }
        })
    }
    const onBranchRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_id: prevState.branch_id.filter((id) => id !== removedOption.id) }
        })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Circle</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="branch_id"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "branches",
                        dataAttr: "branches",
                    }}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onBranchSelect}
                    onRemove={onBranchRemove}
                    singleSelect={true}
                />
            </Form.Group>
        </div>
    </Filters>
};

export default FiltersPartial;

